module.exports = __webpack_public_path__ + "static/media/as.fc950828.png";